'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Renderer = exports.styles = undefined;

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

var _class, _temp; // import MainMenu from './MainMenu';
// import MainPage from "../../pages/MainPage";
// import UsersPage from '../../pages/UsersPage';
// import UserPage from '../../pages/UsersPage/UserPage';
// import RoutedPage from "../../pages/RoutedPage";
// import GraphqlVoyagerPage from "../../pages/GraphqlVoyager";
// import AdminRenderer from "./Admin";


var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRouterDom = require('react-router-dom');

var _context = require('@prisma-cms/context');

var _context2 = _interopRequireDefault(_context);

var _Errors = require('./Errors');

var _Errors2 = _interopRequireDefault(_Errors);

var _Auth = require('../../Auth');

var _Auth2 = _interopRequireDefault(_Auth);

var _ = require('../../pages/404');

var _2 = _interopRequireDefault(_);

var _ContextProvider = require('./ContextProvider');

var _ContextProvider2 = _interopRequireDefault(_ContextProvider);

var _SubscriptionProvider = require('./SubscriptionProvider');

var _SubscriptionProvider2 = _interopRequireDefault(_SubscriptionProvider);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _objectWithoutProperties(obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
} // import AdminPage from '../../pages/admin';
// import Root from '../../pages/Root';
// import {
//   ContextProvider as FrontEditorContextProvider,
//   SubscriptionProvider as FrontEditorSubscriptionProvider,
//   // FrontEditorRoot,
// } from "@prisma-cms/front-editor"
// import RootPage from '../../pages/Root';


var styles = exports.styles = {
  root: {
    // width: "100%",
    flexBasis: "100%",
    height: "100%",
    // maxWidth: 1260,
    // padding: "0 20px",
    // margin: "0 auto",
    display: "flex",
    flexDirection: "column"
  },
  wrapper: {
    width: "100%",
    maxWidth: 1260,
    padding: "0 20px",
    margin: "0 auto"
  },
  body: {}
};
var Renderer = exports.Renderer = (_temp = _class = function (_Component) {
  _inherits(Renderer, _Component);

  function Renderer(props) {
    _classCallCheck(this, Renderer);

    var _this = _possibleConstructorReturn(this, (Renderer.__proto__ || Object.getPrototypeOf(Renderer)).call(this, props));

    _this.forceUpdateBind = function () {
      return _this.forceUpdate();
    };

    _this.state = {
      authOpen: false
    };
    _this.openLoginForm = _this.openLoginForm.bind(_this);
    _this.loginComplete = _this.loginComplete.bind(_this);
    _this.loginCanceled = _this.loginCanceled.bind(_this);
    return _this;
  }

  _createClass(Renderer, [{
    key: 'getChildContext',
    value: function getChildContext() {
      return {
        openLoginForm: this.openLoginForm
      };
    }
  }, {
    key: 'openLoginForm',
    value: function openLoginForm(event) {
      this.setState({
        authOpen: true
      });
    }
  }, {
    key: 'onAuthSuccess',
    value: function onAuthSuccess(data) {
      var onAuthSuccess = this.context.onAuthSuccess;
      return onAuthSuccess(data);
    }
  }, {
    key: 'renderErrors',
    value: function renderErrors() {
      var errors = this.context.errors;
      return _react2.default.createElement(_Errors2.default, {
        errors: errors
      });
    }
  }, {
    key: 'renderAuth',
    value: function renderAuth() {
      var _props = this.props,
          Auth = _props.Auth,
          useMetamask = _props.useMetamask;
      var authOpen = this.state.authOpen;
      return _react2.default.createElement(Auth, {
        open: authOpen,
        useMetamask: useMetamask,
        loginComplete: this.loginComplete,
        loginCanceled: this.loginCanceled
      });
    }
  }, {
    key: 'loginComplete',
    value: function loginComplete(data) {
      this.setState({
        authOpen: false
      });
      this.onAuthSuccess(data);
    }
  }, {
    key: 'loginCanceled',
    value: function loginCanceled() {
      this.setState({
        authOpen: false
      });
    }
  }, {
    key: 'renderMenu',
    value: function renderMenu() {
      // return <MainMenu />
      return null;
    }
  }, {
    key: 'getRoutes',
    value: function getRoutes() {
      var routes = this.props.routes;
      return routes || []; // return [
      //   // {
      //   //   exact: true,
      //   //   path: "/graphql-voyager",
      //   //   component: GraphqlVoyagerPage,
      //   // },
      // ];
    } // getRoutesOld() {
    //   const {
    //     getQueryFragment,
    //   } = this.context;
    //   return [
    //     // {
    //     //   exact: false,
    //     //   path: "/",
    //     //   component: Root,
    //     // },
    //     // {
    //     //   exact: true,
    //     //   path: "/",
    //     //   component: MainPage,
    //     // },
    //     {
    //       exact: true,
    //       path: "/users",
    //       component: UsersPage,
    //     },
    //     {
    //       exact: true,
    //       path: "/users/:userId",
    //       render: (props) => {
    //         const {
    //           params,
    //         } = props.match;
    //         const {
    //           userId,
    //         } = params || {};
    //         return <UserPage
    //           key={userId}
    //           getQueryFragment={getQueryFragment}
    //           where={{
    //             id: userId,
    //           }}
    //           {...props}
    //         />
    //       }
    //     },
    //     {
    //       exact: true,
    //       path: "/graphql-voyager",
    //       component: GraphqlVoyagerPage,
    //     },
    //     // {
    //     //   path: "*",
    //     //   render: props => this.renderOtherPages(props),
    //     // },
    //   ];
    // }
    // renderOtherPages(props) {
    //   const {
    //     uri,
    //   } = this.context;
    //   return <RoutedPage
    //     {...this.props}
    //     {...props}
    //     where={{
    //       path: uri.path(),
    //     }}
    //   />
    // }

  }, {
    key: 'renderRoutes',
    value: function renderRoutes() {
      return _react2.default.createElement(_reactRouterDom.Switch, null, this.getRoutes().map(function (n) {
        var path = n.path;
        return _react2.default.createElement(_reactRouterDom.Route, _extends({
          key: path
        }, n));
      }));
    }
  }, {
    key: 'renderWrapper',
    value: function renderWrapper() {
      // const {
      //   uri,
      //   history,
      // } = this.context;
      // console.log("uri", uri);
      // console.log("uri.toString()", uri.toString());
      // console.log("uri.domain()", uri.domain());
      return this.renderRoutes();
    }
    /**
     * Deprecated
     */

  }, {
    key: 'renderWrapperOld__',
    value: function renderWrapperOld__() {
      var _props2 = this.props,
          classes = _props2.classes,
          other = _objectWithoutProperties(_props2, ['classes']);

      var wrapper = _react2.default.createElement(_react.Fragment, null, _react2.default.createElement('div', {
        id: 'Renderer--header',
        className: classes.wrapper
      }, this.renderMenu()), _react2.default.createElement('div', {
        // item
        // xs={12}
        id: 'Renderer--body',
        className: classes.body
      }, this.renderRoutes()));

      return wrapper || null;
    }
  }, {
    key: 'renderAdmin',
    value: function renderAdmin(wrapper) {
      return wrapper;
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this; // return <Context.Consumer>
      //   {context => {
      //     return <Context.Provider
      //       // value={Object.assign(context, this.context, {
      //       //   ...this.getChildContext(),
      //       //   Avatar,
      //       //   UserLink,
      //       // })}
      //       value={context}
      //     >
      //       "wefwef"
      //     </Context.Provider>
      //   }}
      // </Context.Consumer>


      var currentUser = this.context.user;

      var _ref = currentUser || {},
          currentUserId = _ref.id;

      return _react2.default.createElement(_context2.default.Consumer, null, function (context) {
        return _react2.default.createElement(_context2.default.Provider, {
          value: Object.assign(context, _this2.context, _extends({}, _this2.getChildContext(), {
            rendererForceUpdate: _this2.forceUpdateBind
          }))
        }, _react2.default.createElement(_ContextProvider2.default, null, _react2.default.createElement(_SubscriptionProvider2.default // key={currentUserId}
        , null, _react2.default.createElement(_react.Fragment, null, _this2.renderWrapper(), _this2.renderErrors(), _this2.renderAuth()))));
      });
    }
  }]);

  return Renderer;
}(_react.Component), _class.propTypes = {
  PageNotFound: _propTypes2.default.func.isRequired,
  Auth: _propTypes2.default.func.isRequired,
  classes: _propTypes2.default.object.isRequired,
  routes: _propTypes2.default.array.isRequired,
  useMetamask: _propTypes2.default.bool.isRequired
}, _class.defaultProps = {
  PageNotFound: _2.default,
  Auth: _Auth2.default,
  classes: {},
  routes: [],
  useMetamask: true
}, _class.contextType = _context2.default, _class.childContextTypes = {
  openLoginForm: _propTypes2.default.func
}, _temp);
exports.default = Renderer; // export default withStyles(styles)(Renderer);